<section class="partners">
  <div class="component-content">
    <h3 class="partners__title">
      Our Partners
    </h3>
    <app-partners-list [store]="store"></app-partners-list>
  </div>
</section>
